import { render } from "./UserProfileYetkiSvg.vue?vue&type=template&id=4c98e88e"
import script from "./UserProfileYetkiSvg.vue?vue&type=script&lang=js"
export * from "./UserProfileYetkiSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__